import React, { useEffect, useState } from 'react';
import classes from "./TermsPage.module.css";
import { useSelector } from 'react-redux';

import termsEnglish from "../locales/policies/terms.english.json";
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';

const languageMap = new Map([
    ["0", termsEnglish],
    ["1", termsEnglish],
    ["2", termsEnglish],
    ["3", termsEnglish],
    ["4", termsEnglish],
    ["5", termsEnglish],
    ["6", termsEnglish],
    ["7", termsEnglish],
    ["8", termsEnglish],
    ["9", termsEnglish],
    ["10", termsEnglish],
    ["11", termsEnglish],
    ["12", termsEnglish],
    ["13", termsEnglish],
]);

// const languageMap = new Map([
//   ["0", policyEn],
//   ["1", policyFr],
//   ["2", policyAr],
//   ["3", policyPg],
//   ["4", policySwc],
//   ["5", policyAm],
//   ["6", policyEs],
//   ["7", policySn],
//   ["8", policyTp],
//   ["9", policyKg],
//   ["10", policyId],
//   ["11", policyKm],
//   ["12", policyRu],
//   ["13", policyOm],
// ]);

const TermsPage = () => {
    const { selectedLanguage } = useSelector(state => state.languageSlice);
    const [terms, setTerms] = useState(null);

    const navigate=useNavigate();

    useEffect(() => {
        const mapped = languageMap.get(selectedLanguage) || languageMap.get("0");
        setTerms(mapped);
    }, [selectedLanguage]);

    if (!terms) return null;

    return (
        <div className={classes.container}>
            <div className={classes.sub_container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                </div>

                <div className={classes.msg}>
                    <h2 className={classes.text}>{terms.title}</h2>
                    <p className={classes.paragraph}>{terms.description}</p>

                    {/* Service Info */}
                    <div className={classes.section}>
                        <h3 className={classes.heading}>{terms.product.name}</h3>
                        <p className={classes.paragraph}>{terms.product.description}</p>
                        <p className={classes.paragraph}><strong>Cost:</strong> {terms.product.cost}</p>
                        {/* <p className={classes.paragraph}><strong>Subscription Options:</strong> {terms.product.subscriptionOptions.join(', ')}</p> */}
                    </div>

                    {/* Personal Information Collected */}
                    <div className={classes.section}>
                        <h3 className={classes.heading}>Personal Information We Collect</h3>
                        {terms.personalInformation.informationCollected.map((item, i) => (
                            <p key={i} className={classes.paragraph}>• {item}</p>
                        ))}

                    </div>

                    <div className={classes.section}>
                        <h3>When we collect your personal information</h3>
                        {terms.personalInformation.collectionPoints.map((item, i) => (
                            <p key={i} className={classes.paragraph}>• {item}</p>
                        ))}
                    </div>

                    {/* Usage of Information */}
                    <div className={classes.section}>
                        <h3 className={classes.heading}>How We Use Your Information</h3>
                        <ul className={classes.list}>
                            {terms.usageOfInformation.serviceProvision.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ul>
                    </div>

                    {/* Marketing and Profiling */}
                    <div className={classes.section}>
                        <h3 className={classes.heading}>Marketing and Profiling</h3>
                        <p className={classes.paragraph}>{terms.marketingAndProfiling.description}</p>
                        <p className={classes.paragraph}><strong>How to opt out:</strong></p>
                        <ul className={classes.list}>
                            {terms.marketingAndProfiling.optOutInstructions.map((method, i) => (
                                <li key={i}>{method}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsPage;